// extracted by mini-css-extract-plugin
export var active = "NestedMenuEntry-module--active--5004a";
export var arrowUpAndDown = "NestedMenuEntry-module--arrow-up-and-down--14e33";
export var headerWithOpaqueBackground = "NestedMenuEntry-module--headerWithOpaqueBackground--521d4";
export var icon = "NestedMenuEntry-module--icon--d1ac0";
export var menuLink = "NestedMenuEntry-module--menuLink--39d58";
export var mobile = "NestedMenuEntry-module--mobile--01c57";
export var morePaddingLeft = "NestedMenuEntry-module--morePaddingLeft--a7cc1";
export var nestedEntries = "NestedMenuEntry-module--nestedEntries--82859";
export var nestedEntryOpen = "NestedMenuEntry-module--nestedEntryOpen--1a605";
export var nestedItem = "NestedMenuEntry-module--nestedItem--843cb";
export var subMenuDesktop = "NestedMenuEntry-module--subMenuDesktop--670a7";
export var subMenuWrapperDesktop = "NestedMenuEntry-module--subMenuWrapperDesktop--e9d66";
export var subMenuWrapperMobile = "NestedMenuEntry-module--subMenuWrapperMobile--3ffae";